/* eslint-disable func-names */
/* eslint-disable max-len */
import _ from 'lodash';
import Driver from './Driver';
import Vehicle from './Vehicle';
import Person from './Person';

let nextId;

function PASubmissionLobDataExtension(submission) {
    // eslint-disable-next-line prefer-destructuring
    nextId = submission.nextId;

    const data = submission.lobData.personalAuto.coverables;
    this.removedDrivers_Ext = [];

    if (data && _.isObject(data)) {
        this.drivers = _.map(data.drivers, (d) => {
            const driver = new Driver(d);
            driver.person = submission.findPerson(submission, d.person);
            return driver;
        }, this);

        this.availableInsuredCandidates_Ext = _.map(data.availableInsuredCandidates_Ext, (d) => {
            const driver = new Driver(d);
            driver.person = submission.findPerson(submission, d.person);
            return driver;
        }, this);

        this.vehicles = _.map(data.vehicles, (v) => {
            return new Vehicle(v);
        }, this);

        this.addInterestTypeCategory = data.addInterestTypeCategory;
        this.priorLosses_ML = data.priorLosses_ML;
        this.modifiers_ML = data.modifiers_ML;
        this.vehicleDrivers_Ext = _.map(data.vehicleDrivers_Ext, (d) => {
            return {
                driverID: d.driverID,
                vehicleID: d.vehicleID,
                percentageDriven_Ext: d.percentageDriven_Ext
            };
        }, this);
    } else {
        this.addInterestTypeCategory = '';
        this.availableInsuredCandidates_Ext = [];
        this.drivers = [];
        this.vehicles = [];
        this.priorLosses_ML = [];
        this.modifiers_ML = {};
        this.vehicleDrivers_Ext = [];
    }
};

PASubmissionLobDataExtension.prototype.createDriver = function (person) {
    const driver = new Driver({
        person: person || new Person()
    });
    // extend
    if (person) {
        driver.dateOfBirth = person.dateOfBirth;
    }
    if (person && person.primaryAddress) {
        driver.licenseState = person.primaryAddress.state;
    }
    driver.tempID = nextId();

    this.drivers.push(driver);
    return driver;
};

PASubmissionLobDataExtension.prototype.removeDriver = function (driver) {
    const idx = _.indexOf(this.drivers, driver);
    if (idx >= 0) {
        this.drivers.splice(idx, 1);
    }
};

PASubmissionLobDataExtension.prototype.addRemovedDriverEntry = function (removedDriver) {
    this.removedDrivers_Ext = [...this.removedDrivers_Ext, { DisplayName: removedDriver.person.displayName, RemovalReason: removedDriver.status_ML }];
    return removedDriver;
};

PASubmissionLobDataExtension.prototype.undoRemovedDriverEntry = function () {
    return this.removedDrivers_Ext.pop();
};

PASubmissionLobDataExtension.prototype.createVehicle = function (person) {
    const v = new Vehicle({ tempID: nextId() });
    if (person && person.primaryAddress) {
        v.licenseState = person.primaryAddress.state;
    }
    this.vehicles.push(v);
    return v;
};

PASubmissionLobDataExtension.prototype.removeVehicle = function (vehicle) {
    const idx = _.indexOf(this.vehicles, vehicle);
    if (idx >= 0) {
        this.vehicles.splice(idx, 1);
    }
};

PASubmissionLobDataExtension.prototype.getDriverForPerson = function (person) {
    const driver = _.findWhere(
        this.drivers, { person }
    );

    if (driver.dateOfBirth !== person.dateOfBirth) {
        driver.dateOfBirth = person.dateOfBirth;
    }

    return driver;
};

PASubmissionLobDataExtension.prototype.hasNamedNonOwner = function () {
    return this.vehicles.find((v) => v.namedNonOwner_ML === true) !== undefined;
};
export default PASubmissionLobDataExtension;
